<template>
      <el-card  id='propWin' class="float-prop box-card">
    <el-button style="float: right; padding: 0" @click="closeWin" type="plain" circle icon="el-icon-close"></el-button>
<!--     <div v-for="o in 4" :key="dataObj.properties" class="text item">
      {{'列表内容 ' + o }}
    </div> -->
  </el-card>
</template>
<script>
export default {
  name: 'DefectPropWin',
   data: function() {
    return {
      
      }
  },
  props: ['dataObj'],
  mounted: function() {
        var content = this.dataObj.content;
        $('#propWin').append(content);
        $('#propWin').css("top", this.dataObj.pos.y);
        $('#propWin').css("left", this.dataObj.pos.x);    
  },
  methods: {
    closeWin: function(){
      $('#propWin').hide();
    }
  },
  watch:{
    dataObj:{
      immediate:true,
      handler:function(){
        $('#propWin').css("top", this.dataObj.pos.y);
        $('#propWin').css("left", this.dataObj.pos.x);
        $('#propWin').show();
     }
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .float-prop{
        position:absolute;
        width:250px;
        height:200px; 
        background: rgba(255, 255, 255, 0.35);
    }



</style>



// WEBPACK FOOTER //
// src/plugins/components/Web3dModels/DefectPropertyWin.vue